import {
  QBox,
  QFormControl,
  QMultiSelect,
  QSelectPlaceholder,
  QText,
} from '@qualio/ui-components';
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useTags } from '../../../hooks/useTags';

type TagsFilterFieldProps = {
  name: string;
  dataCy: string;
};

export const TagsFilterField = ({ name, dataCy }: TagsFilterFieldProps) => {
  const { t } = useTranslation();
  const { data: tags = [], isLoading } = useTags();

  const tagsOptions = useMemo(
    () =>
      tags.map((tag) => ({
        value: String(tag.id),
        label: tag.name,
        ...(tag.group_ids.length > 0 && {
          rightIcon: {
            iconName: 'Lock' as const,
            'data-cy': `tag-lock-icon-${tag.id}`,
          },
        }),
      })),
    [tags],
  );

  return (
    <QFormControl label={t('labels.tag')} w="300px">
      <Controller
        name={name}
        render={({ field: { onChange, value, ...field } }) => (
          <QBox data-cy={dataCy}>
            <QMultiSelect
              {...field}
              options={tagsOptions}
              value={value ?? []}
              onChange={(val) => onChange(val.map((option) => option.value))}
              isClearable={true}
              isLoading={isLoading}
              filterOption={({ data: option }, searchTerm) => {
                if (!searchTerm) {
                  return true;
                }

                return option.label
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase());
              }}
            >
              <QSelectPlaceholder>
                <QText>{t('forms.filterByTag')}</QText>
              </QSelectPlaceholder>
            </QMultiSelect>
          </QBox>
        )}
      />
    </QFormControl>
  );
};
